export default {
  home: "Homepage",
  companyProfile: "Company Profile",
  jobPost: "Job Post",
  booking: "Booking",
  manage: "Manage",
  manageFund: "Manage Fund",
};
